import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/crossdock-cost')({
  component: AdminCrossdockCostRoute,
});

function AdminCrossdockCostRoute() {
  return <Outlet />;
}
